import { useEffect, useState, Fragment } from 'react'
import { useParams } from 'react-router-dom'
import { getProductionPlanById, updateProductionPlanComplete } from '../../api/productionPlanApi'
import { getAllCuts } from '../../api/cutApi'
import Input from '../../components/Input'
import { AiFillDelete, AiFillEdit } from 'react-icons/ai'
import { addRollByPlan, deleteRollByPlan, getAllRolls, updateRollByPlan } from '../../api/rollApi'
import useFirstRender from '../../hooks/FirstRender'
import { useApiProgress } from '../../hooks/ApiProgress'
import { LOCATION_PATH, getPageLocations } from '../../api/locationApi'
import { RxCross1 } from 'react-icons/rx'
import { Combobox, Transition, Dialog } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { formatNumber, onChange } from '../../utils/functions'
import { FaPlus } from 'react-icons/fa'
import Button from '../../components/Button'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'

const PlanCompletePage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { planId } = useParams()

    const [plan, setPlan] = useState({})
    const [cuts, setCuts] = useState([])
    const [planCompleteDate, setPlanCompleteDate] = useState("")
    const [parity, setParity] = useState(null)
    const [rolls, setRolls] = useState([])
    const [newRoll, setNewRoll] = useState({
        product: null,
        location: null
    })

    const [locationPage, setLocationPage] = useState({
        content: []
    });
    const isFirstRender = useFirstRender()
    const [locationQuery, setLocationQuery] = useState('')
    const [searchTimerLocation, setSearchTimerLocation] = useState();
    const pendingApiCallLocation = useApiProgress('get', `${LOCATION_PATH}/page`, false)
    const [errors, setErrors] = useState({})

    const [isOpenRollUpdateModal, setIsOpenRollUpdateModal] = useState(false)
    const [updateRoll, setUpdateRoll] = useState({
        location: null,
        boilerCode: "",
        unitPrice: "",
        quantity: ""
    })

    const searchingLocation = async (params) => {
        if (searchTimerLocation) clearTimeout(searchTimerLocation);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    setLocationPage(res.data)
                })
        }, 500);
        setSearchTimerLocation(timer);
    }

    const onClickLoadMoreLocation = () => {
        if (!locationPage.last) {
            loadLocations({ search: locationQuery, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }

    const loadLocations = (params) => {
        !pendingApiCallLocation &&
            getPageLocations(params)
                .then(res => {
                    setLocationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingLocation({ search: locationQuery })
    }, [locationQuery])

    useEffect(() => {
        locationPage.content.length === 0 && loadLocations({ size: 20 })
    }, [])

    useEffect(() => {
        getProductionPlanById(planId)
            .then(res => {
                setPlan(res.data)
                setParity(res.data.parity)
                setPlanCompleteDate(res.data.planCompleteDate)
                // console.log(res.data)
            })
        getAllCuts({ productionPlanId: planId })
            .then(res => {
                console.log(res.data)
                setCuts(res.data)
            })
        getAllRolls({ productionPlanId: planId })
            .then(res => {
                setRolls(res.data)
            })
    }, [planId])

    const onClickEditRoll = (roll) => {
        setIsOpenRollUpdateModal(true)
        setUpdateRoll(roll)
    }

    const onClickDeleteRoll = (id) => {
        deleteRollByPlan(id)
            .then(res => {
                toast.success('Kaydedildi')
            })
            .catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
            .then(() => {
                getAllRolls({ productionPlanId: planId })
                    .then(res => {
                        setRolls(res.data)
                    })
            })
    }

    const onSubmitEditRoll = () => {
        const body = {
            planCompleteDate: planCompleteDate,
            productId: plan.outputDetail.product?.id,
            quantity: updateRoll.quantity,
            locationId: updateRoll.location?.id,
            boilerCode: updateRoll.boilerCode,
            unitPrice: updateRoll.unitPrice,
            productionPlanId: planId,
            parity: parity
        }
        updateRollByPlan(updateRoll.id, body)
            .then(res => {
                toast.success('Kaydedildi')
            })
            .catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
            .then(() => {
                getAllRolls({ productionPlanId: planId })
                    .then(res => {
                        setRolls(res.data)
                        setIsOpenRollUpdateModal(false)
                        setUpdateRoll({
                            location: null,
                            boilerCode: "",
                            unitPrice: "",
                            quantity: ""
                        })
                    })
            })
    }

    const onClickAddRoll = () => {
        const body = {
            planCompleteDate: planCompleteDate,
            productId: plan.outputDetail.product?.id,
            quantity: newRoll.quantity,
            locationId: newRoll.location?.id,
            boilerCode: newRoll.boilerCode,
            unitPrice: newRoll.unitPrice,
            productionPlanId: planId,
            parity: parity
        }
        addRollByPlan(body)
            .then(res => {
                toast.success('Kaydedildi')
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
            .then(() => {
                getAllRolls({ productionPlanId: planId })
                    .then(res => {
                        setRolls(res.data)
                    })
            })

    }

    const onSubmit = () => {
        const body = {
            planCompleteDate,
            parity
        }
        updateProductionPlanComplete(planId, body)
            .then(res => {
                toast('Kaydedildi')
                //nav(-1)
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
            })
            .then(() => {
                getAllRolls({ productionPlanId: planId })
                    .then(res => {
                        setRolls(res.data)
                    })
            })
    }

    return (
        <div>
            <div>
                <label className='text-xl'>Üretim Planı Sonlandır</label>
            </div>
            {/* DETAILS */}
            <div className='grid grid-cols-3 gap-x-5 mb-10'>
                <div className='col-span-1 border-r border-gray-400 pr-5'>
                    <div>
                        <label>Gidecek Ürünler</label>
                    </div>
                    <div>
                        {
                            plan.inputDetails?.map((inputDetail, index) => (
                                <div key={index} className='flex justify-between'>
                                    <label>{inputDetail.product.collectionName}</label>
                                    <label>{formatNumber(inputDetail.quantity)} m</label>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className='col-span-1'>
                    <div>
                        <label>Giden Ürünler</label>
                    </div>
                    <div>
                        {
                            cuts?.map((cut, index) => (
                                <div key={index} className='flex justify-between'>
                                    <label>{cut.roll.product.collectionName}</label>
                                    <label>{formatNumber(cut.quantity)} m</label>
                                </div>
                            ))
                        }
                        <div className='flex justify-between mb-3'>
                            <label>Toplam</label>
                            <label>{formatNumber(cuts.reduce((a, c) => a + c.quantity, 0))} m</label>
                        </div>
                        <label>Toplam Maliyet : {formatNumber(cuts.reduce((a, c) => a + c.quantity * c.roll.unitCost, 0))} USD</label>
                    </div>
                </div>
                <div className='col-span-1 border-l border-gray-400 pl-5'>
                    <div>
                        <label>Beklenen Ürün</label>
                    </div>
                    <div className='flex justify-between'>
                        <label>{plan.outputDetail?.product?.collectionName} </label>
                        <label>{plan.outputDetail?.quantity} m</label>
                    </div>
                </div>

            </div>
            {/* DATE AND PARITY */}
            <div className='grid grid-cols-12 gap-x-3 mb-5'>
                <div className='col-span-2'>
                    <Input
                        label='Tarih'
                        type='date'
                        value={planCompleteDate}
                        name='planCompleteDate'
                        onChange={e => {
                            setPlanCompleteDate(e.target.value)
                            setErrors(prevState => ({ ...prevState, planCompleteDate: undefined }))
                        }}
                        error={errors.planCompleteDate}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        label='Parite'
                        type='number'
                        value={parity}
                        placeholder='Parite girin'
                        onChange={e => {
                            setParity(e.target.value)
                            setErrors(prevState => ({ ...prevState, parity: undefined }))
                        }}
                        error={errors.parity}
                    />
                </div>

            </div>
            <table className='w-full text-left text-zinc-900 mb-3'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>#</th>
                        <th className='p-2 w-3/12'>Ürün</th>
                        <th className='p-2 w-2/12'>Lokasyon</th>
                        <th className='p-2 w-2/12 '>Kazan No</th>
                        <th className='p-2 w-1/12'>Metre</th>
                        <th className='p-2 w-1/12 normal-case'>{`BİRİM FİYAT ${plan.currency}/m`}</th>
                        <th className='p-2 w-1/12 normal-case'>{`BİRİM MALİYET (USD/m)`}</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rolls.map((roll, index) => (
                            <tr key={index} className='border-b items-center text-sm'>
                                <td className='p-2'>
                                    <span className='text-xs'>#</span> {index}
                                </td>
                                <td className='p-2'>{`${plan.outputDetail?.product?.collectionCode}${plan.outputDetail?.product?.color ? `, ${plan.outputDetail?.product?.color.code}` : ""}${plan.outputDetail?.product?.weight ? `, ${plan.outputDetail?.product?.weight.code}` : ""}${plan.outputDetail?.product?.pattern ? `, ${plan.outputDetail?.product?.pattern.code}` : ""}`} </td>
                                <td className='p-2'>{roll.location?.name}</td>
                                <td className='p-2'>{roll.boilerCode}</td>
                                <td className='p-2'>{formatNumber(roll.quantity)}</td>
                                <td className='p-2'>{formatNumber(roll.unitPrice)} <span className='text-xs'>{`${plan?.currency}/m`}</span> </td>
                                <td className='p-2'>{roll.unitCost?.toFixed(4)} <span className='text-xs'>USD/m</span></td>
                                <td className='p-2 flex gap-x-3'>
                                    <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => onClickEditRoll(roll)}>
                                        <AiFillEdit />
                                    </span>
                                    <span
                                        className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                        onClick={() => {

                                            onClickDeleteRoll(roll.id)
                                        }}
                                    >
                                        <AiFillDelete />
                                    </span>
                                </td>
                            </tr>
                        ))
                    }
                    <tr>
                        <td className='p-2'>

                        </td>
                        <td className='p-2'>
                            {`${plan.outputDetail?.product.collectionCode}${plan.outputDetail?.product.color ? `, ${plan.outputDetail?.product.color.code}` : ""}${plan.outputDetail?.product.weight ? `, ${plan.outputDetail?.product.weight.code}` : ""}${plan.outputDetail?.product.pattern ? `, ${plan.outputDetail?.product.pattern.code}` : ""}`}
                        </td>
                        <td>
                            {/* LOCATION PICKER */}
                            <div className="w-full mb-3 col-span-3">
                                <Combobox
                                    value={newRoll.location ? newRoll.location.name : ""}
                                    onChange={(location) => { setNewRoll(prevState => ({ ...prevState, location })); setErrors(prevState => ({ ...prevState, locationId: undefined })) }}
                                >
                                    <div className="relative mt-1">
                                        <div className="relative w-full cursor-default overflow-hidden rounded-md bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300">
                                            <Combobox.Input
                                                placeholder='Arama yapın...'
                                                className="w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 outline-none"
                                                displayValue={newRoll.location?.name}
                                                onChange={(event) => setLocationQuery(event.target.value)}
                                            />
                                            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                <ChevronUpDownIcon
                                                    className="h-5 w-5 text-gray-400"
                                                    aria-hidden="true"
                                                />
                                            </Combobox.Button>
                                        </div>
                                        <Transition
                                            as={Fragment}
                                            leave="transition ease-in duration-100"
                                            leaveFrom="opacity-100"
                                            leaveTo="opacity-0"
                                            afterLeave={() => setLocationQuery('')}
                                        >
                                            <Combobox.Options className="z-50 absolute mt-1 mb-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                                {locationPage.content.length === 0 && locationQuery !== '' ? (
                                                    <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                                                        Kayıt bulunamadı.
                                                    </div>
                                                ) : (
                                                    locationPage.content.map((location) => (
                                                        <Combobox.Option
                                                            key={location.id}
                                                            className={({ active }) =>
                                                                `relative cursor-default select-none ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                }`
                                                            }
                                                            value={location}
                                                        >
                                                            {({ selected, active }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                            }`}
                                                                    >
                                                                        <div className='border p-2 text-xs'>
                                                                            {location.name}
                                                                        </div>

                                                                    </span>
                                                                    {selected ? (
                                                                        <span
                                                                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                                                                }`}
                                                                        >
                                                                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Combobox.Option>
                                                    ))
                                                )}
                                                {
                                                    !locationPage.last &&
                                                    <Combobox.Option
                                                        onClick={e => {
                                                            onClickLoadMoreLocation()
                                                            e.preventDefault()
                                                        }}

                                                        className={({ active }) =>
                                                            `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                            }`
                                                        }

                                                    >
                                                        Daha fazla yükle
                                                    </Combobox.Option>
                                                }
                                            </Combobox.Options>
                                        </Transition>
                                    </div>
                                </Combobox>

                            </div>

                            {errors.locationId && <label className='text-red-600 text-sm'>{errors.locationId} </label>}
                        </td>
                        <td>
                            <Input
                                name="boilerCode"
                                onChange={e => onChange(e, setNewRoll)}
                                value={newRoll.boilerCode}
                                placeholder='Kazan no girin...'
                            />
                        </td>
                        <td>
                            <Input
                                name="quantity"
                                onChange={e => onChange(e, setNewRoll, setErrors)}
                                placeholder='Metre...'
                                type='number'
                                value={newRoll.quantity}
                                error={errors.quantity}
                            />
                        </td>
                        <td>
                            <Input
                                name="unitPrice"
                                onChange={e => onChange(e, setNewRoll, setErrors)}
                                placeholder='Birim fiyat...'
                                type='number'
                                value={newRoll.unitPrice}
                                error={errors.unitPrice}
                            />
                        </td>
                        <td>

                        </td>
                        <td>
                            <div className='flex gap-x-3 pl-5'>
                                <FaPlus className='mb-3 cursor-pointer' onClick={onClickAddRoll} />
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
            <div className='flex justify-center'>
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onSubmit}
                />
            </div>
            <Transition appear show={isOpenRollUpdateModal} as={Fragment}>
                <Dialog as="div" onClose={() => setIsOpenRollUpdateModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                    >
                                        Yeni Plan
                                    </Dialog.Title>

                                    {/* LOCATION PICKER UPDATE */}
                                    <div className="w-full mb-3">
                                        <div className='flex items-center justify-between'>
                                            <span className='flex items-center'>
                                                <label>Lokasyon</label>
                                                {/* {pendingApiCallOperation && <Spinner />} */}
                                            </span>
                                            {
                                                updateRoll?.location &&
                                                <span onClick={() => setUpdateRoll(prevState => ({ ...prevState, location: null }))}>
                                                    <RxCross1 />
                                                </span>
                                            }
                                        </div>
                                        <Combobox value={updateRoll?.location?.name} onChange={(location) => { setUpdateRoll(prevState => ({ ...prevState, location })) }}>
                                            <div className="relative mt-1">
                                                <div className="relative w-full cursor-default overflow-hidden rounded-md bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
                                                    <Combobox.Input
                                                        placeholder='Arama yapın...'
                                                        className="w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 outline-none"
                                                        displayValue={updateRoll.location?.name}
                                                        onChange={(event) => setLocationQuery(event.target.value)}
                                                    />
                                                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                        <ChevronUpDownIcon
                                                            className="h-5 w-5 text-gray-400"
                                                            aria-hidden="true"
                                                        />
                                                    </Combobox.Button>
                                                </div>
                                                <Transition
                                                    as={Fragment}
                                                    leave="transition ease-in duration-100"
                                                    leaveFrom="opacity-100"
                                                    leaveTo="opacity-0"
                                                    afterLeave={() => setLocationQuery('')}
                                                >
                                                    <Combobox.Options className="z-50 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                                        {locationPage.content.length === 0 && locationQuery !== '' ? (
                                                            <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                                                                Kayıt bulunamadı.
                                                            </div>
                                                        ) : (
                                                            locationPage.content.map((location) => (
                                                                <Combobox.Option
                                                                    key={location.id}
                                                                    className={({ active }) =>
                                                                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                        }`
                                                                    }
                                                                    value={location}
                                                                >
                                                                    {({ selected, active }) => (
                                                                        <>
                                                                            <span
                                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                                    }`}
                                                                            >
                                                                                {location.code}
                                                                            </span>
                                                                            {selected ? (
                                                                                <span
                                                                                    className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                                                                        }`}
                                                                                >
                                                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                </span>
                                                                            ) : null}
                                                                        </>
                                                                    )}
                                                                </Combobox.Option>
                                                            ))
                                                        )}
                                                        {
                                                            !locationPage.last &&
                                                            <Combobox.Option
                                                                onClick={e => {
                                                                    onClickLoadMoreLocation()
                                                                    e.preventDefault()
                                                                }}

                                                                className={({ active }) =>
                                                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                    }`
                                                                }

                                                            >
                                                                Daha fazla yükle
                                                            </Combobox.Option>
                                                        }
                                                    </Combobox.Options>
                                                </Transition>
                                            </div>
                                        </Combobox>
                                    </div>
                                    <div>
                                        <Input
                                            label='Kazan no'
                                            name='boilerCode'
                                            type='text'
                                            value={updateRoll.boilerCode}
                                            onChange={e => onChange(e, setUpdateRoll)}
                                        />
                                    </div>
                                    <div>
                                        <Input
                                            label='Miktar (m)'
                                            name='quantity'
                                            type='number'
                                            value={updateRoll.quantity}
                                            onChange={e => onChange(e, setUpdateRoll)}
                                        />
                                    </div>
                                    <div>
                                        <Input
                                            label={`Birim fiyat (${plan?.currency}/m)`}
                                            name='unitPrice'
                                            type='number'
                                            value={updateRoll.unitPrice}
                                            onChange={e => onChange(e, setUpdateRoll)}
                                        />
                                    </div>

                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenRollUpdateModal(false)}
                                        >
                                            İptal

                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 disabled:bg-blue-100"
                                            onClick={onSubmitEditRoll}
                                        //disabled={!variation.color && !variation.pattern && !variation.weight}
                                        >
                                            Kaydet
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default PlanCompletePage